import lateralRaise1 from 'url:../../../assets/images/lateral-raise-ex-1.webp';
import lateralRaise2 from 'url:../../../assets/images/lateral-raise-ex-2.webp';

export const lateralRaiseHexRevealAssets = {
  lateralRaise1,
  lateralRaise2,
} as const;

export const lateralRaiseHexRevealAssetList = Object.values(lateralRaiseHexRevealAssets);
